export function formatFirstNameForDisplay(
  rawName: string | null | undefined,
): string {
  const name = (rawName || '').trim();
  if (!name) return '';
  if (/[\u0590-\u05ff]/.test(name)) return name;
  return name.charAt(0).toLocaleUpperCase() + name.slice(1);
}
